<template>
    <div>
        <div v-if="!sysStudentWrite.visible && !sysStudentImgWrite.visible">
            <!--搜索表单-->
            <div class="search-box selectType">
                <el-form ref="searchForm"  :inline="true" :rules="searchRules" :model="searchForm" >
                    <el-form-item label="年份:" prop="year">
                        <el-date-picker
                                size="mini"
                                v-model="searchForm.year"
                                type="year"
                                placeholder="选择年份"
                                format="yyyy"
                                value-format="yyyy">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="报考专业:" prop="examMajor">
                        <el-select v-model="searchForm.examMajor" size="mini" filterable placeholder="请选择专业">
                            <el-option v-for="item in majorList" :key="item.name" :label="item.name" :value="item.name">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="考场号" prop="examRoomNum">
                        <el-input size="mini" maxlength="32" show-word-limit  v-model="searchForm.examRoomNum" placeholder="请输入考场号" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="教室号" prop="classroomNum">
                        <el-input size="mini" maxlength="32" show-word-limit  v-model="searchForm.classroomNum" placeholder="请输入教室号" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button plain size="mini" type="primary" icon="el-icon-search" id="findBtn" v-display:examRoomPlan-find @click="()=>{this.searchForm.pager.page=1;this.submit();}">查询</el-button>
                        <el-button plain size="mini" type="warning" icon="el-icon-refresh" @click="clear">清空</el-button>
                        <el-button plain size="mini" type="success" icon="el-icon-refresh-left" @click="()=>{this.searchForm.pager.page=1;this.submit();}">刷新</el-button>
                        <el-button plain size="mini" type="primary" v-display:examRoomPlan-printTicketNum  icon="el-icon-download" @click="exportsysExamRoom">导出</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <!--表格-->
            <el-table border size="mini" class="table-ui" :stripe="true"  :data="tableData" @selection-change="changeFun"  @sort-change="sortChange" >
                <el-table-column show-overflow-tooltip prop="examRoomNum" label="考场号" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="classroomNum" label="教室号" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="examMajor" label="报考专业" sortable>
                    <template slot-scope="scope">
                        <p v-for="items in scope.row.sysMajorList">
                            <span v-if="items.name" style="display: block;">{{items.name}}</span>
                        </p>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="name" label="考试时间" width="300">
                    <template slot-scope="scope">
                        <div v-for="items in scope.row.sysMajorList">
                            <p style="text-align: center;font-weight: bold">{{items.name}}</p>
                            <p v-for="item in items.sysMajorItemList">
                                <span v-if="item.name" style="display: block;width: 90px;float: left">{{item.name}}</span>
                                <span v-if="item.examDay" style="margin-left: 10px">{{item.examDay}}</span>
                                <span v-if="item.examStartTime && item.examEndTime" style="margin-left: 10px">{{item.examStartTime.substring(0,5)}}~{{item.examEndTime.substring(0,5)}}</span>
                            </p>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="examMajor" label="考试人数及专业" sortable>
                    <template slot-scope="scope">
                        <p v-for="items in scope.row.sysExamRoomOutList">
                            <span v-if="items.sumStudent && items.examMajor" style="display: block;">{{items.sumStudent}}（{{items.examMajor}}）</span>
                        </p>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="name" label="准考证起始号" width="300">
                    <template slot-scope="scope">
                        <span v-if="scope.row.minTicket">{{scope.row.minTicket}}</span><span v-if="scope.row.maxTicket">~{{scope.row.maxTicket}}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="sumStudent" label="考场人数" sortable></el-table-column>
                <el-table-column fixed="right" label="操作" width="300"  >
                    <template slot-scope="scope">
                        <el-button size="mini" plain type="success" v-display:sysExamRoom-toStudentWrite @click="toStudentWrite(scope.row.examRoomNum,scope.row.classroomNum)">打印签字表</el-button>
                        <el-button size="mini" plain type="success" v-display:sysExamRoom-toStudentImgWrite @click="toStudentImgWrite(scope.row.examRoomNum,scope.row.classroomNum)">打印图像对照单</el-button>
                    </template>
                </el-table-column>
                <div slot="empty"><no-data></no-data></div>
            </el-table>
            <div style="width: 100%;height: 40px">
            </div>
        </div>
        <sys-student-write v-if="sysStudentWrite.visible" v-bind="sysStudentWrite" @closeSysStudentWrite="closeSysStudentWrite"></sys-student-write>
        <sys-student-img-write v-if="sysStudentImgWrite.visible" v-bind="sysStudentImgWrite" @closeSysStudentImgWrite="closeSysStudentImgWrite"></sys-student-img-write>
    </div>
</template>

<script>
    import axios from 'axios';
    import fileDownload from "js-file-download";
    import noData from '@/components/noData/noData';
    import sysStudentWrite from './sysStudentWrite';
    import sysStudentImgWrite from './sysStudentImgWrite';
    export default {
        name: "sysExamRoom",
        components: { noData,sysStudentWrite,sysStudentImgWrite },
        data() {
            return {
                searchForm:{
                    adminId: '',
                    adminName: '',
                    sequence: '',
                    studentId: '',
                    studentName: '',
                    sex: '',
                    idCard: '',
                    examMajor: '',
                    examRoomNum: '',
                    classroomNum: '',
                    seatNumber: '',
                    ticketNumber:'',
                    updateTime: '',
                    createTime: '',
                    pager:{
                        sortField:'examRoomNum',
                        sortOrder:'asc',
                        page:1,
                        pageSize:10,
                        totalCount:0,
                        like:'examMajor,examRoomNum,classroomNum'
                    }
                },
                tableData: [],
                upsertForm:{
                    id:'',
                    adminId:'',
                    adminName:'',
                    sequence:'',
                    studentId:'',
                    studentName:'',
                    sex:'',
                    idCard:'',
                    examMajor:'',
                    examRoomNum:'',
                    classroomNum:'',
                    seatNumber:'',
                    ticketNumber:'',
                    updateTime:'',
                    createTime:''
                },
                searchRules: {
                    adminId: [
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    adminName: [
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    sequence: [
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    studentId: [
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    studentName: [
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    sex: [
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    idCard: [
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    examMajor: [
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    examRoomNum: [
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    classroomNum: [
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    seatNumber: [
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    updateTime: [
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    createTime: [
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                },
                rules: {
                    adminId: [
                        { required: true, message: '请输入操作人编', trigger: 'blur' },
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    adminName: [
                        { required: true, message: '请输入操作人', trigger: 'blur' },
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    sequence: [
                        { required: true, message: '请输入学生序号', trigger: 'blur' },
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    studentId: [
                        { required: true, message: '请输入学生编号', trigger: 'blur' },
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    studentName: [
                        { required: true, message: '请输入考生姓名', trigger: 'blur' },
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    sex: [
                        { required: true, message: '请输入性别', trigger: 'blur' },
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    idCard: [
                        { required: true, message: '请输入身份证号', trigger: 'blur' },
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    examMajor: [
                        { required: true, message: '请输入报考专业', trigger: 'blur' },
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    examRoomNum: [
                        { required: true, message: '请输入考场号', trigger: 'blur' },
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    classroomNum: [
                        { required: true, message: '请输入教室号', trigger: 'blur' },
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    seatNumber: [
                        { required: true, message: '请输入座位号', trigger: 'blur' },
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    updateTime: [
                        { required: true, message: '请输入修改时间', trigger: 'blur' },
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    createTime: [
                        { required: true, message: '请输入创建时间', trigger: 'blur' },
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                },
                dialog:{
                    dialogFormVisible:false,
                    title:'增加'
                },
                majorList:[],
                sysStudentWrite:{
                    visible:false,
                    title:'打印签字表',
                    examRoomNum:'',
                    classroomNum:'',
                },
                sysStudentImgWrite:{
                    visible:false,
                    title:'打印图像对照单',
                    examRoomNum:'',
                    classroomNum:'',
                },
            }
        },
        created(){
            this.$set(this.searchForm,"year", new Date().getFullYear().toString())
            this.getMajorList();
        },
        mounted(){
           this.submit();
        },
        methods: {
            changeFun(row) {
                this.rowData = [];
                for (var i = 0; i < row.length; i++) {
                    this.rowData.push(row[i].id);
                }
            },
            sortChange({ column, prop, order }){
                this.searchForm.pager.sortField=prop;
                this.searchForm.pager.sortOrder=order?order.replace(/ending$/,''):'';
                this.submit();
            },
            sizeChange(pageSize){
                this.searchForm.pager.pageSize=pageSize;
                this.submit();
            },
            currentChange(page){
                this.searchForm.pager.page=page;
                this.submit();
            },
            submit(){
                axios({
                    url:`${home}/sysExamRoom/findExamRoomPlan`,
                    method:'POST',
                    data:this.searchForm
                }).then(res=>{
                    this.tableData=res.data;
                }).catch(function (error) {
                    console.log(error);
                });
            },
            clear(){
                this.$refs['searchForm'].resetFields();
            },
            exportsysExamRoom() {
                axios({
                    url: `${home}/sysExamRoom/exportSysExamRoomPlain`,
                    method: "POST",
                    data: this.searchForm,
                    responseType: "arraybuffer"
                }).then(res => {
                    var yearNane = new Date().getFullYear();
                    fileDownload(res, "武汉晴川学院  "+yearNane+"  年普通专升本招生考试考场安排表.xls");
                });
            },
            toStudentWrite(examRoomNum,classroomNum){
                this.sysStudentWrite.title='打印签字表';
                this.sysStudentWrite.examRoomNum=examRoomNum;
                this.sysStudentWrite.classroomNum=classroomNum;
                this.sysStudentWrite.visible=true;
            },
            closeSysStudentWrite(){
                this.sysStudentWrite.visible=false;
                this.submit();
            },
            getMajorList(){
                axios({
                    url: `${home}/sysDdList/getMajorList`,
                    method: "GET",
                }).then(res => {
                    this.majorList = res.data;
                });
            },
            toStudentImgWrite(examRoomNum,classroomNum){
                this.sysStudentImgWrite.title='打印图像对照单';
                this.sysStudentImgWrite.examRoomNum=examRoomNum;
                this.sysStudentImgWrite.classroomNum=classroomNum;
                this.sysStudentImgWrite.visible=true;
            },
            closeSysStudentImgWrite(){
                this.sysStudentImgWrite.visible=false;
                this.submit();
            },
        }
    }
</script>
<style lang="scss">
    .selectType{
        .el-input__inner{
            width: 150px;
        }
        .el-input .el-input--mini {
            width: 150px;
        }
        .el-date-editor.el-input, .el-date-editor.el-input__inner {
            width: 150px;
        }
    }
</style>